<template>
  <div>
    <label>
      <input
        type="checkbox"
        :checked="modelValue"
        @input="update($event.target.checked)"
        :class="fieldClasses.input"
      />
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: { required: true },
    required: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => {}
    },
    uuid: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      required: true
    },
    fieldClasses: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    update(value) {
      this.$emit("update:modelValue", value);
    }
  }
};
</script>
